import { Subject } from 'rxjs'

export const UserGeometrySynced = new Subject<void>()
